import { determineEnv } from '@fd/common/api/determineEnv';
import { useEffect } from 'react';
import { AppRouter } from './Router';
import { getUser } from './auth/user';
import { logout } from './auth/logout';
import { loadUserLocalStorage } from '@fd/common/frontend/loadUserFromLocalStorage';
import { Toaster } from './components/ui/Toaster';
import { redirectAfterSignIn } from './auth/redirectAfterSignIn';
import { useSession } from './context/session/useSession';

function App() {
  const { session } = useSession();
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const gclid = urlParams.get('gclid');
    const utm_source = urlParams.get('utm_source');
    const utm_campaign = urlParams.get('utm_campaign');
    const utm_medium = urlParams.get('utm_medium');

    if (gclid) {
      localStorage.setItem('gclid', gclid);
    }
    if (utm_source) {
      localStorage.setItem('utm_source', utm_source);
    }
    if (utm_campaign) {
      localStorage.setItem('utm_campaign', utm_campaign);
    }
    if (utm_medium) {
      localStorage.setItem('utm_medium', utm_medium);
    }
  }, []);

  useEffect(() => {
    if (session) {
      redirectAfterSignIn();
    }
  }, [session]);

  return (
    <>
      <AppRouter />
      <Toaster />
    </>
  );
}

if (determineEnv() === 'prod') {
  import('gleap').then(async ({ default: Gleap }) => {
    Gleap.initialize('CWj4jRuTVZQUzLwHAC06nEUK0nfLudLh');
    const user = await getUser();
    if (user) {
      Gleap.identify(user.id, { email: user.email });
      const urlParams = new URLSearchParams(window.location.search);
      const signedUp = urlParams.get('signedUp');
      if (signedUp) {
        Gleap.trackEvent('User signed up', {
          userId: user.id,
          email: user.email,
        });
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete('signedUp');
        window.history.replaceState({}, '', newUrl);
      }
    }
  });
}

if (loadUserLocalStorage()) logout();

export default App;
